<template>
    <banner-alert
        type="error"
        :icon="icon"
        :closable="false">
        <div class="banner-copy">
            <span class="is-bold">{{ bannerCopy }}</span>
            {{ $t('globalBanner.As a non-member of the subscription, consider contacting a subscription admin before proceeding.') }}
        </div>
        <template #actions>
            <pendo-button
                :pendo-analytics="`global-banner:${GLOBAL_BANNER_TYPES.SUPPORT_ACCESS_WARNING}` + `:unimpersonate`"
                :data-cy="`unimpersonate:button`"
                :label="$t('Unimpersonate')"
                size="mini"
                @click="unimpersonate" />
        </template>
    </banner-alert>
</template>

<script>
import BannerAlert from '@/common/banner-notification/banner-alert/banner-alert.vue';
import GLOBAL_BANNER_TYPES from '@/constants/global-banner-types';
import { PendoButton } from '@pendo/components';

export default {
    name: 'SupportAccessWarning',
    components: {
        BannerAlert,
        PendoButton,
    },
    props: {
        homeSubscription: {
            type: Object,
            required: true,
        },
    },
    data () {
        return {
            GLOBAL_BANNER_TYPES,
            icon: {
                type: 'alert-circle',
                stroke: 'var(--palette-red-80)',
            },
        };
    },
    computed: {
        bannerCopy () {
            if (!this.$activeSubscription?.autoGrantAccessExpiresOn) {
                return this.$t('globalBanner.{ subscriptionName } does not have support access enabled.', { subscriptionName: this.$activeSubscription.displayName });
            }

            return this.$t('globalBanner.Support access to { subscriptionName } has expired.', { subscriptionName: this.$activeSubscription?.displayName });
        },
    },
    methods: {
        unimpersonate () {
            this.$router.pendo.switchSubscription(this.homeSubscription.id);
        },
    },
};
</script>

<style lang="less" scoped>
.pendo-banner {
    :deep(.pendo-alert) {
        background-color: var(--palette-red-20);
    }
    .is-bold {
        font-weight: bold;
    }
}
</style>
